import Anchor from "../../../../lib/html5-software-library/src/ranj/layout/Anchor";
import ContextEvent from "../application/ContextEvent";
import Config from "../config/Config";
import NavigateEvent from "../navigation/NavigateEvent";
import SoundType from "../sound/util/SoundType";
import StartupEvent from "../startup/StartupEvent";
import AbstractMediator from "../ui/AbstractMediator";
import Button from "/lib/html5-software-library/src/ranj/components/buttons/Button";
import AnimationDuration from "/lib/html5-software-library/src/ranj/ui/animation/AnimationDuration";
import AnimationFactory from "/lib/html5-software-library/src/ranj/ui/animation/AnimationFactory";
import AnimationOptions from "/lib/html5-software-library/src/ranj/ui/animation/AnimationOptions";
import { getURLParameter } from "/lib/html5-software-library/src/ranj/util/URLUtil";

export default class SplashLoadScreenMediator extends AbstractMediator {
    constructor(target, dispatcher, startup, soundManager, config, screenNavigator, layoutManager) {
        super(target, dispatcher, layoutManager);
        console.info("SplashLoadScreenMediator constructor");
        this._soundManager = soundManager;
        this.dispatcher = dispatcher;
        this._startup = startup;
        this._config = config;
        this._screenNavigator = screenNavigator;

        this.setProgress(0);

        this._handlePreloadCompleteBound = this.handlePreloadComplete.bind(this);
        this._handleLoadProgressBound = this.handleLoadProgress.bind(this);
    }

    initialize() {
        super.initialize();

        this._startup.addEventListener(StartupEvent.PROGRESS, this._handleLoadProgressBound);
        this._startup.addEventListener(StartupEvent.COMPLETE, this._handlePreloadCompleteBound);

        var buttonStartSkin = this._target.startButton;
        this._buttonStartGame = new Button(buttonStartSkin);
        this._buttonStartGame.skin.visible = false;

        this._onStartButtonWasClicked = this.onStartButtonWasClicked.bind(this);
        this._buttonStartGame.addEventListener("click", this._onStartButtonWasClicked);

        if (this._config.getValue("settings.showVersionOnSplash")) {
            this._showVersion();
        }

        this.stretchBackground();
    }

    destroy() {
        super.destroy();

        this._startup.removeEventListener(StartupEvent.PROGRESS, this._handleLoadProgressBound);
        this._startup.removeEventListener(StartupEvent.COMPLETE, this._handlePreloadCompleteBound);
    }

    _showVersion() {
        var buildId = this._config.getValue(Config.BUILDID);
        var commitHash = this._config.getValue(Config.COMMIT_HASH);

        this._versionTextContainer = new createjs.Container();
        this._target.addChild(this._versionTextContainer);
        this.anchorObject(this._versionTextContainer, Anchor.B);
        this._versionText = new createjs.Text(buildId + " - " + commitHash, "10px Arial", "#8a8a8a");
        this._versionText.textAlign = "center";
        this._versionTextContainer.addChild(this._versionText);
        this._versionText.y = this._screenNavigator.getScreenHeight() * .5 - 20;
    }

    handleLoadProgress(event) {
        var progress = event.data.progress;
        this.setProgress(progress);
    }

    setProgress(progress) {
        var t = this._target.loadingBar.duration;
        var percentage = Math.round(t * progress);
        this._target.loadingBar.gotoAndStop(Math.min(t - 1, percentage));
    }

    onStartButtonWasClicked(event) {
        this._buttonStartGame.removeEventListener("click", this._onStartButtonWasClicked);

        this._soundManager.playSound(SoundType.CLICK);
        this._soundManager.initializeStreamChannels("./assets/sounds/silent.mp3");
        console.info("[SplashLoadScreenMediator]", "Start Button Was Clicked", event);

        // Start the game!
        // NOTE: Do not move this back into a callback from the animation below.
        // The StartGameCommand initializes a video player, and that *needs* to
        // be done from a user gesture callback *or it won't work on mobile*.
        var contextEvent = new ContextEvent(ContextEvent.START_GAME);
        this.dispatcher.dispatch(contextEvent.type, { data: contextEvent });

        // Close this screen, with transition
        var animationOptions = new AnimationOptions(0, AnimationDuration.NORMAL, createjs.Ease.sineInOut); //delay, duration, ease
        var commandEvent = new NavigateEvent(NavigateEvent.CLOSE_SCREEN_REQUEST, null, this._target, null, null, null, null, AnimationFactory.FADE_OUT, animationOptions);
        this.dispatcher.dispatch(commandEvent.type, { data: commandEvent });
    }

    handlePreloadComplete(event) {
        this._startup.removeEventListener(StartupEvent.PROGRESS, this._handleLoadProgressBound);
        this._startup.removeEventListener(StartupEvent.COMPLETE, this._handlePreloadCompleteBound);
        this._target.loadingBar.visible = this._target.loadingTextField.visible = false;
        this._buttonStartGame.skin.visible = true;
        //
        if (getURLParameter("autostart") == "1") {
            setTimeout(function () { this.onStartButtonWasClicked(); }.bind(this), 15);
        }
    }
}